export default __webpack_public_path__ + "static/media/arrow-right.744de0bd.svg";